import type { ScanHistory } from "."

export const isFailed = (record: ScanHistory) => record.scanStatus === "failed"

export const isCompleted = (record: ScanHistory) =>
  record.scanStatus === "completed"

export const isScanning = (record: ScanHistory) =>
  record.scanStatus === "scanning"

export const isNA = (record: ScanHistory) =>
  isFailed(record) && noPolicyResult(record)

export const noPolicyResult = (record: ScanHistory) => !record.policyResult

export const noPolicyName = (record: ScanHistory) => !record.policyName

export const isNAPolicyResult = (record: ScanHistory) =>
  record.policyResult === "na"

export const isCI = (record: ScanHistory) => record.sourceControl === "OnPrem"

export const isCIOpenSource = (record: ScanHistory) =>
  isCI(record) && record.scanType === "ci_open_source"

export const isCIImageOpenSource = (record: ScanHistory) =>
  isCI(record) && record.scanType === "ci_image_open_source"

export const isCICodeWeakness = (record: ScanHistory) =>
  isCI(record) && record.scanType === "ci_code_weakness"
